import { i18n } from "@/boot/i18n";
import DomainService from "@/services/domain";
import ErrorHandler from "@/tools/errorHandler";
import { EMAILS, MIN_LENGTH, REQUIRED, ESPECIAL_CHARACTER } from "../validator/methods";
import * as types from "./mutationTypes";

export default {
  initState({ commit, dispatch }) {
    commit(types.SET_DOMAINS, []);
    const validator = validators();
    dispatch("validator/addValidator", validator.domainValidator, { root: true });
    dispatch("validator/addValidator", validator.emailsValidator, { root: true });
    dispatch("validator/addValidator", validator.subdomainValidator, { root: true });
  },
  clearState({ commit }) {
    commit(types.CLEAR_DOMAINS);
    commit(types.CLEAR_DOMAIN);
  },
  setDomainsSuccess({ commit }, domains) {
    commit(types.SET_DOMAINS, domains);
  },
  setDomainSuccess({ commit }, domain) {
    commit(types.SET_DOMAIN, domain);
  },
  setEmailsSuccess({ commit }, emails) {
    emails = emails.map((email) => email.email);
    commit(types.SET_EMAILS, emails);
  },
  async getAll({ rootState, dispatch }) {
    try {
      const response = await DomainService.getAll(rootState.organization.organization.uuid);
      if (response.data.data) {
        dispatch("setDomainsSuccess", response.data.data);
      }
    } catch (error) {
      dispatch("ui/showToastError", ErrorHandler.getErrorMessage(error), { root: true });
    }
  },
  async delete({ rootState, dispatch, commit }, domainUUID) {
    try {
      await DomainService.delete(rootState.organization.organization.uuid, domainUUID);
      commit(types.REMOVE_DOMAIN, domainUUID);
      dispatch("ui/showToastSuccess", i18n.t("domain.messages.success_remove_domain"), { root: true });
    } catch (error) {
      dispatch("ui/showToastError", ErrorHandler.getErrorMessage(error), { root: true });
    }
  },
  async save({ rootState, dispatch, state }) {
    const valid = await dispatch("validate");
    if (!valid) {
      return false;
    }
    try {
      let response = null;
      if (state.domain.uuid) {
        response = await DomainService.update(rootState.organization.organization.uuid, state.domain);
      } else {
        response = await DomainService.create(rootState.organization.organization.uuid, state.domain);
      }
      dispatch("setDomainSuccess", response.data.data);
      return true;
    } catch (error) {
      if (error.response.data.message === "Wrong domain in email list") {
        dispatch("ui/showToastError", i18n.t("domain.messages.email_wrong"), { root: true });
      } else {
        dispatch("ui/showToastError", ErrorHandler.getErrorMessage(error), { root: true });
      }

      return false;
    }
  },
  async verify({ rootState, dispatch }, domainUUID) {
    try {
      const response = await DomainService.verify(rootState.organization.organization.uuid, domainUUID);
      if (response.data.data) dispatch("setDomainSuccess", response.data.data);
    } catch (error) {
      dispatch("ui/showToastError", ErrorHandler.getErrorMessage(error), { root: true });
    }
  },
  async getEmails({ rootState, dispatch }) {
    try {
      const response = await DomainService.getEmails(rootState.organization.organization.uuid);
      if (response.data.data) {
        dispatch("setEmailsSuccess", response.data.data);
      } else {
        dispatch("setEmailsSuccess", []);
      }
    } catch (error) {
      dispatch("ui/showToastError", ErrorHandler.getErrorMessage(error), { root: true });
    }
  },
  setDomain({ commit }, domain) {
    commit(types.SET_DOMAIN, domain);
  },
  setFieldDomain({ commit, dispatch }, domain) {
    commit(types.SET_FIELD_DOMAIN, domain);
    dispatch("validator/checkValidation", { field: "domain", value: domain }, { root: true });
  },
  setFieldSubdomain({ commit, dispatch }, subdomain) {
    commit(types.SET_FIELD_SUBDOMAIN, subdomain);
    dispatch("validator/checkValidation", { field: "subdomain", value: subdomain }, { root: true });
  },
  async setFieldEmails({ commit, dispatch }, emails) {
    const valid = await dispatch("validator/validate", { field: "email_list", value: emails }, { root: true });
    if (valid) {
      commit(types.SET_FIELD_EMAILS, emails);
    }
  },
  clearEmails({ commit }) {
    commit(types.CLEAR_EMAILS);
  },
  validate({ rootState, dispatch, state }) {
    dispatch("validator/validate", { field: "domain", value: state.domain.domain }, { root: true });
    dispatch("validator/validate", { field: "email_list", value: state.domain.email_list }, { root: true });
    if (state.domain.subdomain) {
      dispatch("validator/validate", { field: "subdomain", value: state.domain.subdomain }, { root: true });
    }

    return rootState.validator.errors.length === 0;
  }
};

const validators = () => {
  return {
    domainValidator: {
      field: "domain",
      validations: [{ method: REQUIRED, message: i18n.t("general.rules.required") }]
    },
    subdomainValidator: {
      field: "subdomain",
      validations: [{ method: ESPECIAL_CHARACTER, message: i18n.t("general.rules.especial_character") }]
    },
    emailsValidator: {
      field: "email_list",
      validations: [
        { method: MIN_LENGTH, value: 1, message: i18n.t("general.rules.required") },
        { method: EMAILS, message: i18n.t("general.rules.email") }
      ]
    }
  };
};
